export default __webpack_public_path__ + "static/N0196-f682811804d18b2cb04efe7db31e6115.png";